import { EditorView } from "prosemirror-view";
import { EditorState } from "prosemirror-state";
import {
  schema,
  defaultMarkdownParser, MarkdownParser,
  defaultMarkdownSerializer, MarkdownSerializer
} from "prosemirror-markdown";
// can be modified to get a decent start at an editor
// https://github.com/prosemirror/prosemirror-example-setup
import { exampleSetup } from "prosemirror-example-setup";
// flattens the parser tree for debug console.log(recurse(parser.parse(someText)))
var recurse = (node) => {
  node.t = node?.type?.name;
  let childList = [node];
  if (node?.content?.content.length === 0) {
    return childList;
  }
  else if (node?.content?.content) {
    for (let i = 0; i < node.content.content.length; i++) {
      childList = childList.concat(recurse(node.content.content[i]));
    }
  }
  return childList;
};

// Define a custom tokenizer that treats \n\n as hard breaks
// take the markdownit instance from default parser and modify it
let customTokenizer = defaultMarkdownParser.tokenizer;
customTokenizer.disable(["link"]);
customTokenizer.inline.ruler.disable(["link"]);
customTokenizer.inline.ruler.disable(["linkify"]);
customTokenizer.inline.ruler.disable(["image"]);
customTokenizer.inline.ruler.disable(["autolink"]);

customTokenizer.disable(["heading"]);
customTokenizer.block.ruler.disable(["heading"]);

customTokenizer.disable(["lheading"]);
customTokenizer.block.ruler.disable(["lheading"]);

customTokenizer.disable(["code"]);
customTokenizer.block.ruler.disable(["code"]);

customTokenizer.disable(["blockquote"]);
customTokenizer.block.ruler.disable(["blockquote"]);

customTokenizer.disable(["fence"]);
customTokenizer.block.ruler.disable(["fence"]);

customTokenizer.disable(["backticks"]);
customTokenizer.inline.ruler.disable(["backticks"]);

// console.log(defaultMarkdownParser);
// console.log(customTokenizer);
// console.log(schema);
delete schema.nodes.heading;
delete defaultMarkdownParser.tokens.heading;

delete schema.marks.code;
delete schema.nodes.code_inline;
delete defaultMarkdownParser.tokens.code_inline;

delete schema.nodes.code_block;
delete defaultMarkdownParser.tokens.code_block;

delete schema.nodes.fence;
delete defaultMarkdownParser.tokens.fence;

delete schema.nodes.blockquote;
delete defaultMarkdownParser.tokens.blockquote;

delete schema.nodes.image;
delete defaultMarkdownParser.tokens.image;

delete schema.nodes.link;
delete schema.marks.link;
delete defaultMarkdownParser.tokens.link;
// replacing this function https://github.com/markdown-it/markdown-it/blob/0fe7ccb4b7f30236fb05f623be6924961d296d3d/lib/rules_block/state_block.mjs#L119
// this function replacement represents 3 hours of stepping through code and debugging :^)
customTokenizer.block.State.prototype.skipEmptyLines = (from) => { return from; };
const customMarkdownParser = new MarkdownParser(schema, customTokenizer, {
  ...defaultMarkdownParser.tokens,
});

// Extend the default markdown serializer to parse <p><br/></p>  as a \n\n
// console.log(defaultMarkdownSerializer);
const customMarkdownSerializer = new MarkdownSerializer(
  {
    ...defaultMarkdownSerializer.nodes,
    paragraph (state, node) {
      if (node.childCount === 0) {
        state.write("\n\n");
        return;
      }
      state.renderInline(node);
      state.closeBlock(node);
    },
  },
  defaultMarkdownSerializer.marks
);

class ProseMirrorView {
  constructor(target, content, options) {
    // console.log(content);
    // console.log(customMarkdownSerializer.serialize(customMarkdownParser.parse(content)));
    options = options ?? {};
    this.ChangeListeners = [];
    // this.parser = defaultMarkdownParser;
    this.parser = customMarkdownParser;
    // this.serializer = defaultMarkdownSerializer;
    this.serializer = customMarkdownSerializer;
    let view = new EditorView(target, {
      state: EditorState.create({
        doc: this.parser.parse(content),
        plugins: exampleSetup({ schema, menuBar: false, }),
      }),
      dispatchTransaction: (transaction) => {
        this.sendChangeEvent(transaction);
        let newState = view.state.apply(transaction);
        view.updateState(newState);
      },
      ...options
    });
    this.view = view;
  }
  updateContent (content) {
    this.view.updateState(EditorState.create({
      doc: customMarkdownParser.parse(content),
      plugins: exampleSetup({ schema, menuBar: false, }),
    }));
    // this.view.update({});
  }
  sendChangeEvent (e) {
    this.ChangeListeners.forEach(fn => { if (fn) fn(e); });
  }
  onChange (fn) {
    this.ChangeListeners.push(fn);
  }
  get content () {

    return this.serializer.serialize(this.view.state.doc);
  }
  focus () { this.view.focus(); }
  destroy () { this.view.destroy(); }
}

export { ProseMirrorView };